type ActionSummaryItem = {
  id: string
  title: string
  subtitle?: string
  value: string
}

type ActionSummaryCardProps = {
  items: ActionSummaryItem[]
  totalLabel: string
  totalValue: string
}

export function ActionSummaryCard({ items, totalLabel, totalValue }: ActionSummaryCardProps) {
  return (
    <>
      <div className="rounded-lg border border-outline-variant divide-y divide-surface-variant">
        {items.map((item) => (
          <div key={item.id} className="flex items-center justify-between gap-3 p-3">
            <div>
              <p className="text-body-lg font-semibold text-on-surface">{item.title}</p>
              {item.subtitle && (
                <p className="text-label-md text-on-surface-variant">{item.subtitle}</p>
              )}
            </div>
            <p className="text-body-lg font-bold text-primary">{item.value}</p>
          </div>
        ))}
      </div>

      <div className="rounded-lg bg-surface-container p-3 flex items-center justify-between">
        <span className="text-body-sm text-on-surface-variant">{totalLabel}</span>
        <span className="text-body-lg font-bold text-on-surface">{totalValue}</span>
      </div>
    </>
  )
}
